export const PALETTES = [
  { id: "logo-gold", name: "أزرق الشعار وذهبي", primary: "#01336A", panel: "#0A4A8F", accent: "#F5B921", accent2: "#F7C948", bg: "#F2F6FB", onAccent: "#01336A" },
  { id: "logo-white", name: "أزرق الشعار وأبيض", primary: "#013B79", panel: "#0B4F9C", accent: "#FFFFFF", accent2: "#E6EEF8", bg: "#EEF3FA", onAccent: "#013B79" },
  { id: "navy", name: "كحلي وذهبي", primary: "#0F1B3D", panel: "#1A2752", accent: "#F5B921", accent2: "#F7C948", bg: "#F4F6FB", onAccent: "#0F1B3D" },
  { id: "emerald", name: "زمردي ورملي", primary: "#064E3B", panel: "#0B6B52", accent: "#D4A24C", accent2: "#E5B969", bg: "#F6F3EC", onAccent: "#062E24" },
  { id: "maroon", name: "عنابي وذهبي", primary: "#5B1A2B", panel: "#74253A", accent: "#E0B04A", accent2: "#EEC66B", bg: "#F8F4F1", onAccent: "#3B0F1B" },
  { id: "black", name: "أسود وبرتقالي", primary: "#141414", panel: "#262626", accent: "#F97316", accent2: "#FB923C", bg: "#F5F5F4", onAccent: "#FFFFFF" },
  { id: "royal", name: "أزرق ملكي وسماوي", primary: "#1E3A8A", panel: "#2747A3", accent: "#38BDF8", accent2: "#7DD3FC", bg: "#F1F5F9", onAccent: "#0B1E4D" },
];

export const SITE_FONTS = [
  { id: "Tajawal", name: "تجوّل" }, { id: "Cairo", name: "القاهرة" }, { id: "Almarai", name: "المراعي" },
  { id: "IBM Plex Sans Arabic", name: "IBM Plex عربي" }, { id: "Changa", name: "تشانغا" }, { id: "Readex Pro", name: "ريدكس" },
];

export const FONTS_URL = "https://fonts.googleapis.com/css2?family=Cairo:wght@400;700;900&family=Tajawal:wght@400;500;700;800&family=Almarai:wght@400;700;800&family=IBM+Plex+Sans+Arabic:wght@400;600;700&family=Changa:wght@400;600;700&family=Readex+Pro:wght@400;600;700&display=swap";

export const INVOICE_FONTS = [
  { id: "Amiri", name: "أميري", note: "الخط الحالي — كلاسيكي رسمي" },
  { id: "Cairo", name: "القاهرة", note: "عصري وعريض" },
  { id: "Tajawal", name: "تجوّل", note: "عصري خفيف ونظيف" },
  { id: "Almarai", name: "المراعي", note: "معتمد للفواتير" },
  { id: "IBMPlex", name: "IBM Plex عربي", note: "رسمي تقني" },
  { id: "Changa", name: "تشانغا", note: "هندسي مميز" },
];
